export const HeaderContact = class {
  openClass = 'faqPopinOpen';
  isOpen = false;

  constructor() {
    $('.js-show-faq-popin').on('click', (e) => {
      e.preventDefault();
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });

    $('.js-hide-faq-popin').on('click', (e) => {
      e.preventDefault();
      this.close();
    });

    $('.js-hover-show-faq-popin, .js-faq-popin')
      .on('mouseenter', () => {
        this.open();
      })
      .on('mouseleave', () => {
        this.close();
      });

    $(document).on('click scroll', (e) => {
      const $target = $(e.target);
      if (!$target.closest('.js-show-faq-popin, .js-hover-show-faq-popin, .js-faq-popin').length) {
        this.close();
      }
    });
  }

  open() {
    $('body')
      .addClass(this.openClass)
      .removeClass('navDisplayed');
    this.isOpen = true;
  }

  close() {
    $('body').removeClass(this.openClass);
    $('html').removeClass('disableScrollFaqPopin');
    this.isOpen = false;
  }
};